import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_sc6x2al4xm: FaireBrandEntity = {
  token: "b_sc6x2al4xm",
  type: "brand",
  name: "Maine Root Craft Soda",
  avatarUrl:
    "https://cdn.faire.com/fastly/0fc608c083d91f811658486a9131eb903cd47bd4fe15f74ac3746a4400c95b5a.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/b726d32291a24e702ddfb58a5e9e99ded1a7eb60924fd01d223efa2156c9d4ab.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/0fc608c083d91f811658486a9131eb903cd47bd4fe15f74ac3746a4400c95b5a.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b726d32291a24e702ddfb58a5e9e99ded1a7eb60924fd01d223efa2156c9d4ab.jpeg",
  location: "Portland, ME, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    "Born in Maine. Enjoyed everywhere.\n\nOnce upon a time, our founder Matt Seiler found himself slinging all-natural pizzas at Flatbread Company in Portland, Maine. Most everything he served was organic, except the sodas, so Matt went to work creating a delicious root beer without all the bad stuff. Today, Maine Root offers a variety of handcraft beverages – from ginger brews to lemonade – and is sold in over 7,500 locations worldwide.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:50.579Z",
    importedBy: "entity-db-cli",
  },
};
